import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import WaveSpecs from "@/components/waves/specs/WaveSpecs";
import WaveGroups from "@/components/waves/groups/WaveGroups";
interface BrainRightSidebarContentProps {
  readonly wave: ApiWave;
}
const BrainRightSidebarContent: React.FC<BrainRightSidebarContentProps> = t0 => {
  const $ = _c(2);
  const {
    wave
  } = t0;
  let t1;
  if ($[0] !== wave) {
    t1 = <div className="tw-flex tw-flex-col tw-overflow-y-auto"><WaveSpecs wave={wave} useRing={false} /><WaveGroups wave={wave} useRing={false} /></div>;
    $[0] = wave;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default BrainRightSidebarContent;